/* eslint-disable */
import { useEffect, useState } from "react";
import * as API from '../../../../../../src/framework/API/api'
import { utility } from "../../../../../framework/utility/utilityProvider";
import Page from "./Page";
import { useLocation } from "react-router-dom";
import { ENTITYNAME, MODULE, SOCKET_ACTION, SOCKET_EVENTS, TOAST_TYPES } from "../../../../../framework/constant/constant";
import useSocket from "../../../../../framework/socket/useSocket";
import ToastNotification from "../../../../../components/ToastNotification";
import { useTranslation } from "../../../../../locale/useTranslation";

const Preview = (props) => {
    console.log(props);

    const lang = useTranslation();
    const location = useLocation();

    const [page, setPage] = useState([]);
    const [ottSetting, setOttSetting] = useState({});
    const [bottomMenu, setBottomMenu] = useState([]);
    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(props.isMobile);

    useEffect(() => {

        if (location.state && location.state.page) {
            setPage(location.state.page);
            setIsMobile(location.state.isMobile);
            setLoading(false);
        } else if (props.pageData) {
            setPage(props.pageData);
            setLoading(false);
        } else {
            setIsMobile(props.isMobile);
            loadData();
        }

    }, [props.isMobile, location?.state?.page])

    useSocket(SOCKET_EVENTS.onSocketData, (socketData) => {

        if (socketData.module != MODULE.PLATFORM) return;

        switch (socketData.action) {
            case SOCKET_ACTION.PLATFORM_THEME_REFRESH:
            case SOCKET_ACTION.PLATFORM_GRID_REFRESH:
            case SOCKET_ACTION.PLATFORM_PAGE_REFRESH:
            case SOCKET_ACTION.PLATFORM_MENU_REFRESH:
            case SOCKET_ACTION.PLATFORM_RAIL_REFRESH:
                loadOttSettings();
                break;
            default:
                break;
        }
    });

    const loadData = async () => {
        try {
            setLoading(true);
            const response = await API.getLayout3();
            if (response.success) {
                const pagesData = response.data.pages;
    
                // Get OTT settings and bottom menu before deciding the page
                const settings = await loadOttSettings(); 
                let bottomMenuData = [];
                if (settings?.showBottomMenu) {
                    bottomMenuData = await loadBottomMenu(); 
                }
    
                if (pagesData.length > 0) {
                    setPages(pagesData);
                    utility.setValue('pages', pagesData);
    
                    let selectedPage = props.pageData ?? undefined;
                    let pageToSet;
    
                    if (settings?.showBottomMenu && bottomMenuData.length > 0) {
                        pageToSet = pagesData.find(p => p._id === bottomMenuData[0]._id) 
                                    || pagesData.find(p => p.IsHomePage);
                    } else {
                        pageToSet = selectedPage
                            ? pagesData.find(x => x._id === selectedPage._id)
                            : pagesData.find(p => p.IsHomePage);
                    }
    
                    if (pageToSet) {
                        setPage(pageToSet);
                    } else {
                        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No Home Page Found" });
                    }
                }
            }
        } catch (err) {
            console.error("Error loading data:", err);
        } finally {
            setLoading(false);
        }
    };
    
    const loadOttSettings = async () => {
        let res = await API.getOttSettings();
        if (res.success) {
            setOttSetting(res.data);
            return res.data;
        }
        return {};
    };
    
    const loadBottomMenu = async () => {
        let res = await API.getBottomMenu();
        if (res.success) {
            setBottomMenu(res.data.Pages ?? []);
            return res.data.Pages ?? [];
        }
        return [];
    };    

    const changePage = (id) => {
        setPage(pages.filter(x => x._id == id)[0]);
    }

    return loading ?
        <div style={{ height: "95%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <i className="fa fa-spin fa-spinner fa-2xl" />
        </div>
        : <div style={{ position: "relative" }}>
            <i style={props?.style ?? { position: "sticky", top: "5px", left: "5px", color: "white", zIndex: "99999", cursor: "pointer" }} className="fa fa-refresh fa-xl" onClick={() => {
                loadData();
            }} />
            <Page bgColor={props?.bgColor} page={page} isMobile={isMobile} ottSetting={ottSetting} bottomMenu={bottomMenu} changePage={changePage} />
        </div>
}

export default Preview;